import { normalizeDimension } from "../../../../helpers/utils";

const style = ({ theme, childrenSpacing }) => ({
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
        flexDirection: "column",
        alignItems: "stretch",
    },
    "& .buttonsCol_item": {
        display: "flex",
        justifyContent: "center",
        "& + .buttonsCol_item": {
            marginRight: normalizeDimension(childrenSpacing, true),
            [theme.breakpoints.up("md")]: {
                marginRight: 0,
                marginTop: normalizeDimension(childrenSpacing, true),
            },
        },
    },
});

export default style;
